export enum ReviewingPartyReason {
  RedoCoveredByPpPlus = "REDO_COVERED_BY_PP_PLUS",
  MerchantNotAClaim = "MERCHANT_NOT_A_CLAIM",
  MerchantPpPlusNotEnabled = "MERCHANT_PP_PLUS_NOT_ENABLED",
  MerchantNotPackageProtected = "MERCHANT_NOT_PACKAGE_PROTECTED",
  MerchantWrongProduct = "MERCHANT_WRONG_PRODUCT",
  MerchantClaimRejectedByThirdPartyInsurer = "MERCHANT_CLAIM_REJECTED_BY_THIRD_PARTY_INSURER",
  MerchantSkippedPpPlusDocumentation = "MERCHANT_SKIPPED_PP_PLUS_DOCUMENTATION",
}
